export default "__VITE_ASSET__f4Q$uA48__"